"use client";

import { useRuntimeConfig } from "@finbackoffice/site-core";
import { FeedScopeEnum } from "utils/constants";
import { RouteNames } from "utils/constants";
import { usePathnameWithLocal } from "hooks/base/usePathnameWithLocal";

export const useGetCurrentFeedType = (): FeedScopeEnum => {
    const COMMON_SITE_CONFIGS = useRuntimeConfig("COMMON_SITE_CONFIGS");
    const { pathnameValues, pathname } = usePathnameWithLocal();
    const isSportCalendar = pathname.includes(RouteNames.CALENDAR);
    const isSportMultiView = pathname.includes(RouteNames.MULTI_VIEW);
    const isUpcoming = pathname.includes(`${RouteNames.SPORT}/${RouteNames.UPCOMING}`);
    const isPrematchUpcoming = pathnameValues.includes(
        `${RouteNames.PREMATCH}/${RouteNames.UPCOMING}`,
    );

    if (!COMMON_SITE_CONFIGS.contentVerticals.sport) {
        return "" as FeedScopeEnum;
    }

    if (isSportCalendar || isSportMultiView || isUpcoming) {
        return FeedScopeEnum.live;
    } else if (isPrematchUpcoming) {
        return FeedScopeEnum.prematch;
    }

    return pathnameValues[1] as unknown as FeedScopeEnum;
};
